import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const propTypes = {
  name: PropTypes.string,
};
const defaultProps = {
  name: '',
};

const titleProject = 'title-project';

const ProjectTitle = ({ name }) => <Typography className={titleProject}>{name}</Typography>;

ProjectTitle.propTypes = propTypes;
ProjectTitle.defaultProps = defaultProps;
export default ProjectTitle;
